import RoundedButton from 'components/RoundedButton';
import { getCookie } from 'utils/cookie';
import { getMe } from 'api/auth';
import { suggestPrize } from 'api/feedback';
import React, { useState } from 'react';
import GreenPageSection from 'components/GreenPageSection';
import Subheading from 'components/Subheading';

const SubmitPrizeSection = ({ prizeCategory, descriptionText, suggestAPrizeId }) => {
  const [prizeText, setPrizeText] = useState('');
  const [prizeSubmitted, setPrizeSubmitted] = useState(false);

  return (
    <GreenPageSection id={suggestAPrizeId}>
      {!prizeSubmitted ? (
        <>
          <Subheading className="normal-case">Suggest a prize..</Subheading>

          <p
            style={{
              maxWidth: '500px',
              fontWeight: 600,
              textAlign: 'center',
              fontSize: '1.1em',
            }}
          >
            {descriptionText}
          </p>
          <div
            style={{ height: '75px' }}
            className="bg-white w-full md:w-2/5 lg:w-1/3 rounded-full flex py-5 px-5 justify-between mt-5"
          >
            <input
              className="border-none hover:bg-gray-100 w-full mr-2 rounded-full px-3"
              placeholder="I'd love to win a..."
              autoComplete="off"
              onChange={(e) => {
                setPrizeText(e.target.value);
              }}
            />
            <RoundedButton
              style={{ minWidth: '100px' }}
              onClick={async () => {
                let userId;
                const jwt = getCookie('jwt', null);
                if (jwt) {
                  const user = await getMe(jwt);
                  userId = user.id;
                }
                const res = await suggestPrize(
                  prizeCategory,
                  prizeText,
                  userId
                );
                if (res.successful === true) {
                  setPrizeSubmitted(true);
                }
              }}
            >
              SUBMIT
            </RoundedButton>
          </div>
        </>
      ) : (
        <p
          style={{
            margin: '2em 1em',
            maxWidth: '300px',
            fontWeight: 'bold',
            fontSize: '1.1em',
          }}
        >
          Thanks for your suggestion! We'll be sure to review it soon.
        </p>
      )}

      <style jsx>{`
        textarea {
          margin-top: 20px;
          background-color: white;
          font-size: 17px;
          border: none;
          padding: 0.5em 1em;
          width: 100%;
          max-width: 500px;
          height: 90px;
          border-radius: 9px;
        }
      `}</style>
    </GreenPageSection>
  );
};

export default SubmitPrizeSection;
